<style lang="less" scoped>
  .default-btn {
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 32px;
    padding: 10px 0;
    display: flex;
    align-items: center;
    border-radius: 32px;
    height: 64px;
    border: none;
    background: white;
    justify-content: center;
    color: #18a4ff;
  }
  .icon {
    width: 32px;
    height: 32px;
    margin-right: 16px;
  }
</style>

<template lang="pug">
  button.default-btn(
    @click='clicked',
    :type='type')
    img.icon(
      v-if='icon'
      :src='icon')
    span {{text}}
</template>


<script>
export default {
  props: {
    type: {
      type: String,
      default: 'button',
    },
    icon: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
  },
  methods: {
    clicked() {
      this.$emit('click');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/button.vue